exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".styles__root___11cq4 {\n  max-width: 940px;\n  margin: 0 auto;\n}\n\n.styles__editor___1EMga {\n  border: solid 1px black;\n  padding: 1rem;\n}\n", "", {"version":3,"sources":["/./src/containers/App/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;CAChB;;AAED;EACE,wBAAwB;EACxB,cAAc;CACf","file":"styles.css","sourcesContent":[".root {\n  max-width: 940px;\n  margin: 0 auto;\n}\n\n.editor {\n  border: solid 1px black;\n  padding: 1rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"root": "styles__root___11cq4",
	"editor": "styles__editor___1EMga"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&sourceMap&importLoaders=2&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/containers/App/styles.css
// module id = 505
// module chunks = 0